import React from "react";
import { Tag, Popover } from "antd";
import { isExpired, expiresIn1MonthFromNow } from "../utils/date-utils";
import moment from "moment-timezone";

// FIXME: Automatically disabled during ESLint config update
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const ExpTag = React.forwardRef<any, any>(
  // FIXME: Automatically disabled during ESLint config update
  // @ts-expect-error TODO(typecheck-unify): TS6133 'ref' is declared but its value is never read.
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  ({ expires, popover = "", placement, isNonExpiringRequirement = false, ...props }, ref) => {
    let color = "";
    if (isExpired(expires)) {
      color = "red";
    } else if (expiresIn1MonthFromNow(expires)) {
      color = "orange";
    }
    if (!popover) {
      return <Tag color={color} {...props} />;
    }
    if (typeof expires === "undefined") {
      // FIXME: Automatically disabled during ESLint config update
      // eslint-disable-next-line no-param-reassign
      popover = "Missing Expiration Date";
    } else {
      // FIXME: Automatically disabled during ESLint config update
      // eslint-disable-next-line no-param-reassign
      popover = "Expiration: " + moment(expires).endOf("day").fromNow();
    }

    if (isNonExpiringRequirement) {
      color = "default";
      // FIXME: Automatically disabled during ESLint config update
      // eslint-disable-next-line no-param-reassign
      popover = "Does not expire";
    }
    return (
      <Popover placement={placement || "top"} content={popover}>
        <Tag color={color} {...props} />
      </Popover>
    );
  }
);

export default ExpTag;
